import $ from "jquery";
import Kefir from "kefir";
import initPage from "./page/initPage.js";

// add's UA info to html class (needed for iPad)
import "./sniff.min.js";

import createIntroMap from "./viz/intro-map.js";
import hrrCentroids from "../data/hrrs.json";
import usShape from "../data/us.json";

import createCorncob from "./viz/corncob.js";
import createLocationOverall from "./viz/location-overall.js";
import createIndicatorOverall from "./viz/indicator-overall.js";
import createSesScatter from "./viz/ses-scatter.js";
import createSpread from "./viz/spread.js";
import createSpreadExpanded from "./viz/spread-expanded.js";

import { reflow$, resize$, toPropertyFromResize } from "./page/common.js";
import { maxVizHeight$ } from "./page/initStickyViz.js";

import {loadVizData} from "./viz/loadVizData.js";

import {simpleSource, zipHrrSource, createTypeAhead} from "./page/typeAhead.js";

import { scrollBodyTo } from "./page/initNav.js";


// initialize purple map
const mapWidth = () => Math.min($(window).width(), 800);
const introMap = createIntroMap({
    selector: ".js-viz-intro-map",
    width: mapWidth(),
    usShape,
    hrrCentroids
});

resize$.onValue(e => {
    introMap.setState({
        width: mapWidth()
    });
});

loadVizData()
    .then(json => {
        const { cleanData, locations, indicators, zips } = json;

        /* corncob */
        const corncob = createCorncob({
            selector: ".js-viz-corncob",
            width: $(".js-viz-corncob").width(),
            rankings: cleanData,
            locations,
            indicators
        });

        resize$.onValue(e => {
            corncob.setWidth($(".js-viz-corncob").width());
        });


        /* indicator overall  */
        const indicatorOverall = createIndicatorOverall({
            selector: ".js-viz-indicator-overall",
            width: $(".js-viz-indicator-overall").width(),
            locations, indicators, cleanData,
            afterSlide: () => {
                reflow$.emit("indicator slide");
            }
        });

        resize$.onValue(e => {
            indicatorOverall.setWidth($(".js-viz-indicator-overall").width());
        });


        /* location overall */
        const locationOverallSelector = ".js-viz-location-overall";

        const locationOverall = createLocationOverall({
            selector: locationOverallSelector,
            width: $(locationOverallSelector).width(),
            height: 550,
            locations, indicators, cleanData,
            onUnlock: function(){
                // clear the typeahead when the active location is unlocked
                locationOverallTypeAhead.setValue("");
            }
        });

        resize$.onValue(e => {
            locationOverall.setWidth($(locationOverallSelector).width());
        });


        // location overall typeahead
        const locationOverallTypeAhead = createTypeAhead(
            ".js-viz-location-overall__typeahead .typeahead",
            "name",
            zipHrrSource(locations, zips),
            function(hrr){
                locationOverall.setActiveLocation(hrr.id);
            }
        );

        $(".js-trigger-jonesboro").on("click", (event) => {
            event.preventDefault();
            locationOverall.setActiveLocation(18);

            // if the viz is stacked, scroll to it
            if (!$("body").hasClass("sticky")){
                scrollBodyTo($("#chapter2 .viz-section").offset().top, 400);
            }
        });



        /* spread viz */
        const spreadExpandedSelector = ".js-viz-spread-expanded";
        const spreadSelector = ".js-viz-spread";
        const spreadWidth = () => $(spreadSelector).width();
        const spreadExpandedWidth = () => spreadWidth() - 22; // 22 for padding + border
        // the container includes the viz title // 32 for padding + border + box-shadow
        const spreadExpandedHeight = () => Math.min($(".js-viz-spread-container").height() - 32, spreadExpandedWidth());

        // spread
        const spread = createSpread({
            selector: spreadSelector,
            width: spreadWidth(),
            locations,
            indicators,
            cleanData,
            onIndicatorClick: function(ind){
                spreadExpanded.setActiveIndicator(ind);
                $(spreadSelector).addClass("fade");
            }
        });

        resize$.onValue(e => {
            spread.setWidth(spreadWidth());
        });

        // spread popup
        const spreadExpanded = createSpreadExpanded({
            selector: spreadExpandedSelector,
            width: spreadExpandedWidth(),
            height: spreadExpandedHeight(),
            locations,
            indicators,
            cleanData,
            activeIndicator: null,
            onClose: () => {
                $(spreadSelector).removeClass("fade");
            }
        });

        resize$.onValue(e => {
            spreadExpanded.setState({
                width: spreadExpandedWidth(),
                height: spreadExpandedHeight()
            });
        });




        /* scatter plot */
        const sesScatterSelector = ".js-viz-ses-scatter";
        const scatterMaxWidth$ = toPropertyFromResize(() => $(sesScatterSelector).width());

        // Scatter typeahead
        const scatterTypeahead = createTypeAhead(".js-viz-ses-scatter__typeahead .typeahead",
        "shortName",
        simpleSource(i => i.shortName, indicators),
        function(ind){
            sesScatter.setActiveIndicator(ind.id);
        });

        const sesScatter = createSesScatter({
            selector: sesScatterSelector,
            locations,
            indicators,
            cleanData,
            activeIndicator: "a001",
            onActiveIndicatorChange: (ind) => {
                scatterTypeahead.setValue(ind.shortName);
            }
        });


        // a stream that calculates the size of the scatter plot
        // both scatterMaxWidth$ and maxVizHeight$ are properties, so this will fire immediately onValue
        const scatterSize$ = Kefir.combine(
            [scatterMaxWidth$, maxVizHeight$],
            (maxWidth, maxVizHeight) => {
                // available space minus the header
                const maxHeight = maxVizHeight - $(".js-viz-scatter-header").height() - 10; // 10 padding
                return Math.min(maxHeight, maxWidth);
            }
        );

        scatterSize$.onValue((size) => {
            sesScatter.setSize(size);
        });

        $(".js-tigger-age-gender-cancer-screenings").on("click", (event) => {
            event.preventDefault();
            sesScatter.setActiveIndicator("q001a");
        });




        reflow$.emit("viz's loaded");
    });


/** initialize all the page scripts for navigation and sticky vizs, etc **/
initPage();


// cloak hides all the content. now that we've done all our layout crunching,
// show the content
$("body").removeClass("cloak");
